import { Redirect, useLocation, RouteComponentProps } from "react-router-dom";
import { useRecoilValue } from "recoil";

import { AllstarUser } from "../../State";
import Profile from "../../Views/Profile";

const ProfileRedirect = (props: RouteComponentProps) => {
  const allstarUser = useRecoilValue(AllstarUser);
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const userParam = searchParams.get("user");
  const username =
    allstarUser.user?.profile?.username || allstarUser.user?.username;

  if (userParam) return <Profile {...props} />;
  if (!allstarUser.loggedIn) return <Redirect to="/login" />;

  return username ? (
    <Redirect to={`/u/${username}${location.search}`} />
  ) : (
    <Redirect to="/login" />
  );
};

export { ProfileRedirect };
